export default __webpack_public_path__ + "static/media/logo.af74ad20.png";